module.exports = __webpack_public_path__ + "static/media/IconRotate.3b0e6b06.svg";